/** How a mark moves when its data changes, and that it does not under reduced motion.
 *
 * Motion in a chart is **state feedback**: a bar that moved because the period or the basis
 * changed tells the reader the figure under it is a different figure. It is never an entrance
 * flourish, so marks are drawn at their final geometry on first paint (`initial={false}`) and this
 * transition only runs on a change. Under `prefers-reduced-motion` the duration is zero, so every
 * mark is at its final value immediately and nothing loops (ADR-0090).
 *
 * Motion values are not used for the marks themselves because a mark's geometry is data, not a
 * per-frame count: `motion.rect` interpolates `x`/`y`/`width`/`height` outside React's render cycle.
 */

import { useReducedMotion } from "motion/react";

export function useChartTransition() {
  const reduce = useReducedMotion();
  return reduce
    ? ({ duration: 0 } as const)
    : ({ duration: 0.22, ease: "easeOut" } as const);
}
